
import {
    defineComponent,
    toRef,
    watch,
    onMounted,
    toRefs,
    inject,
    ref,
    reactive
} from "vue";
import LogoArea from "./sider/LogoArea.vue";
import MenuList from "./sider/MenuList.vue";
import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";
import {
    TweenMax
} from "gsap";
import {
    Menu
} from "./utils/types";

//TODO 待增加菜单尺寸调整功能：大、中、小

export default defineComponent({
    name: "CigoSider",
    components: {
        LogoArea,
        MenuList
    },
    setup(props, context) {
        let Env = reactive(process.env);
        let menuTreeListRef: any = inject("menuTreeListRef"); //Tips_FLAG 父变子变示例1/3：provide & inject
        let menuOpenFlag = toRef(
            CigoAdminStore.getState().systemState,
            "sideMenuOpen"
        );

        watch(menuOpenFlag, (openFlag: boolean, preOpenFLag: boolean) => {
            menuChange(openFlag);
        });

        onMounted(() => {
            menuChange(menuOpenFlag.value);
        });

        const menuChange = (openFlag: boolean) => {
            TweenMax.to(
                [
                    ".cigo-sider",
                    ".sider-logo-area",
                    ".sider-menu-list",
                    ".copy-right"
                ],
                0.8, {
                    width: openFlag ? "240px" : "103px",
                    onStart: () => {
                        if (openFlag) {
                            CigoAdminStore.setLeftMenuContainerWidth("250px");
                        }
                    },
                    onComplete: () => {
                        if (!openFlag) {
                            CigoAdminStore.setLeftMenuContainerWidth("113px");
                        }
                    }
                }
            );
        };

        return {
            Env,
            ...toRefs(CigoAdminStore.getState().systemState),
            menuTreeListRef
        };
    }
});
